import { Pictogram, Skeleton } from '../../../../core-components';

import type { FC } from 'react';

type DashboardStageOverviewHeaderProps = {
  fallback?: boolean;
  temperature?: number;
  cabinNumber?: string;
  cabinNumberText?: string;
  bookingCode?: string;
  bookingCodeText?: string;
};

export const DashboardStageOverviewHeader: FC<
  DashboardStageOverviewHeaderProps
> = ({
  temperature,
  cabinNumber,
  cabinNumberText = 'Ihre Kabine:',
  fallback,
  bookingCode,
  bookingCodeText = 'Ihre Buchungsnummer:',
}) => {
  if (!fallback && !temperature && !bookingCode && !cabinNumber) {
    return null;
  }

  return (
    <div className="flex justify-between">
      {(fallback || temperature !== undefined) && (
        <div className="flex gap-1 items-end">
          {fallback && (
            <>
              <Skeleton className="size-[40px]" />
              <Skeleton className="h-3 w-16" />
            </>
          )}
          {!fallback && temperature !== undefined && (
            <>
              <Pictogram name="sun" size="sm" />
              <p className="headline-lg">{temperature}°</p>
            </>
          )}
        </div>
      )}

      {(fallback || cabinNumber || bookingCode) && (
        <ul className="flex-1 flex flex-col justify-end text-right [&_strong]:headline-sm [&_strong]:ml-1">
          {fallback && (
            <>
              <li>
                <Skeleton className="h-2 w-16 inline-block" />{' '}
                <Skeleton className="h-2 w-8 inline-block" />
              </li>
              <li>
                <Skeleton className="h-2 w-20 inline-block" />{' '}
                <Skeleton className="h-2 w-14 inline-block" />
              </li>
            </>
          )}

          {!fallback && cabinNumber && (
            <li>
              <span>{cabinNumberText}</span>
              <strong>{cabinNumber}</strong>
            </li>
          )}

          {!fallback && bookingCode && (
            <li>
              <span>{bookingCodeText}</span>
              <strong>{bookingCode}</strong>
            </li>
          )}
        </ul>
      )}
    </div>
  );
};
